<div class="promptuary-export">
	<div>
		<div
			class="zk-flex zk-gap-2 promptuary-export__back-wrapper"
			(click)="redirectToCalendar()"
		>
			<span class="freud-icon freud-icon-arrow-left zk-pointer"></span>
			<span class="zk-pointer">{{
				'EXPORT.BACK_TO_CALENDAR' | translate
			}}</span>
		</div>
	</div>
	<div
		*ngIf="!isExperied"
		class="
		promptuary-export__available
			zk-gap-5
			zk-mt-4
		"
	>
		<span
			class="
				promptuary-export__icon
				freud-icon freud-icon-file-export freud-icon-xl
			"
		></span>
		<span class="promptuary-export__title">{{
			'EXPORT.PROMPTUARY_PAGE_TITLE' | translate
		}}</span>
		<div class="promptuary-export__description">
			<span>{{
				'EXPORT.EXPORT_FOR'
					| translate
						: {
								customer: exportData?.customerName,
								date: exportData?.startDate
						  }
			}}</span>
			<span>{{
				'EXPORT.AVAILABLE_UNTIL' | translate: { date: exportData?.endDate }
			}}</span>
		</div>
		<re-captcha
			(resolved)="onRecaptchaResolved($event)"
			[siteKey]="recaptchaSiteKey"
		></re-captcha>
		<div>
			<div *ngIf="isDownloading" lass="zk-flex zk-flex-col zk-items-center">
				<freud-loader size="lg"></freud-loader>
				<span>{{'EXPORT.DOWNLOADING_FILE' | translate}}</span>
			</div>
			<freud-button
				*ngIf="!isDownloading"
				[disabled]="!isRecaptchaResolved"
				(click)="downloadPromptuary()"
			>
				<div class="zk-flex zk-gap-3">
					<span>{{ 'EXPORT.DOWNLOAD' | translate }}</span>
					<span class="freud-icon freud-icon-download"></span>
				</div>
			</freud-button>
		</div>
		
	</div>
	<div *ngIf="isExperied" class="promptuary-export__expired zk-gap-5 zk-mt-4">
		<span
			class="
				promptuary-export__icon
				freud-icon freud-icon-mood-confuzed freud-icon-xl
			"
		></span>
		<span class="promptuary-export__title">{{
			'EXPORT.PROMPTUARY_PAGE_TITLE_EXPIRED' | translate
		}}</span>
		<div class="promptuary-export__description">
			<span>{{
				'EXPORT.WAS_AVAILABLE_UNTIL'
					| translate
						: {
								date: exportData?.endDate
						  }
			}}</span>
			<span>{{
				'EXPORT.MAKE_NEW_IMPORT' | translate
			}}</span>
		</div>
		<freud-button [disabled]="true">
			<div class="zk-flex zk-gap-3">
				<span>{{ 'EXPORT.DOWNLOAD' | translate }}</span>
				<span class="freud-icon freud-icon-download"></span>
			</div>
		</freud-button>
	</div>
</div>
